
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../../../hooks/useAuthContext.js'



export default function ReturnPage() {
  const [status, setStatus] = useState('loading');
  const [sessionId, setSessionId] = useState(null);

  const {dispatch} = useAuthContext()


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get('session_id');
    setSessionId(sid);

    (async () => {
      if (!sid) { setStatus('error'); console.log('no session id'); return; }

      // Optional: call backend to get the session status
      const res = await fetch(`http://localhost:5000/api/sessions/${sid}`);
      if (res.ok) {
        const data = await res.json();
        setStatus('complete');
        
      } else {
        
        setStatus('error');
      }
    })();
  }, []);

  return (
    <div className="max-w-xl mx-auto py-12">
      <h1 className="text-2xl font-semibold">Subscription</h1>
      {status === 'complete' && (
        <>
          <p className="mt-2">Verify your email 🎉</p>
          
        </>
      )}
      {status === 'loading' && <p>Verifying subscription…</p>}
      {status === 'error' && <p>Couldn’t verify subscription status.</p>}
    </div>
  );
}
